module.exports = __webpack_public_path__ + "Profile400x589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Profile400x589.jpg
// module id = 297
// module chunks = 0